import axiosInstance from "@/api/axiosInstance";

interface CollectPaymentRequest {
  useStoredProfile?: boolean;
  dataDescriptor?: string;
  dataValue?: string;
}

interface CollectPaymentResponse {
  success: boolean;
  transactionId?: string;
  amount?: number;
}

export async function collectEnrollmentPayment(
  enrollmentId: number,
  data: CollectPaymentRequest,
): Promise<CollectPaymentResponse> {
  const response = await axiosInstance.post(
    `/api/private/enrollments/${enrollmentId}/collect-payment`,
    data,
  );
  return response.data?.data ?? response.data;
}
